import { IRootState } from "../reducers";
import { IRenewalInvoiceStatus } from "../../services/api/subscription/types";
import { Invoice } from "../../types/common";
import { IRenewalInvoiceState } from "./types";

export const selectRenewalInvoiceState = (
  state: IRootState,
): IRenewalInvoiceState => {
  return state.renewalInvoice;
};

export const selectRenewalInvoiceStatus = (
  state: IRootState,
  subscriptionId: string,
): IRenewalInvoiceStatus | undefined => {
  return selectRenewalInvoiceState(state)?.statusById[subscriptionId];
};

export const selectIsFetchingRenewalInvoiceStatus = (
  state: IRootState,
  subscriptionId: string,
): boolean => {
  return !!selectRenewalInvoiceState(state)?.isFetchingById[subscriptionId];
};

export const selectIsCreatingRenewalInvoice = (
  state: IRootState,
  subscriptionId: string,
): boolean => {
  return !!selectRenewalInvoiceState(state)?.isCreatingById[subscriptionId];
};

// Pay-attempt error takes precedence over background fetch error.
export const selectRenewalInvoiceError = (
  state: IRootState,
  subscriptionId: string,
): string | undefined => {
  const renewalInvoiceState = selectRenewalInvoiceState(state);

  return (
    renewalInvoiceState?.errorById[subscriptionId] ??
    renewalInvoiceState?.statusErrorById[subscriptionId]
  );
};

// Status fetch failed for this subscription.
export const selectIsRenewalInvoiceStatusFailed = (
  state: IRootState,
  subscriptionId: string,
): boolean => {
  return !!selectRenewalInvoiceState(state)?.statusFailedById[subscriptionId];
};

// Last POST-returned invoice; only verified checkout URL to offer.
export const selectLastCreatedRenewalInvoice = (
  state: IRootState,
  subscriptionId: string,
): Invoice | undefined => {
  const lastCreated = selectRenewalInvoiceState(state)?.lastCreated;

  return lastCreated?.subscriptionId === subscriptionId
    ? lastCreated.invoice
    : undefined;
};
